<template>
    <div>
        <v-btn v-if="provider.settings.allow_public_scheduling"
               color="primary"
               depressed
               :fab="$vuetify.breakpoint.smAndDown"
               round
               dark
               @click="$refs.stepper.show()"
        >
            <v-icon :left="$vuetify.breakpoint.mdAndUp">fa-calendar-alt</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">Agendar cita</span>
        </v-btn>

        <appointment-provider-stepper
            v-if="provider"
            ref="stepper"
            :service-provider="provider"
            :internal="false"
        />

    </div>
</template>

<script>
import AppointmentProviderStepper from "@/components/appointments/AppointmentProviderStepper";

export default {
    name: "AppointmentPicker",
    components: {AppointmentProviderStepper},
    props: {
        provider: {
            type: Object,
            required: true
        }
    },
    mounted() {
        if(this.open) this.$refs.stepper.show()
    },
    computed: {
        open(vm = this) {
            return vm.$route.query.open === 'true'
        }
    },
}
</script>

<style scoped>

</style>